export const LSKeys = {
  userToken: "newTalToken",
  userName: "talUserName",
  userAvatar: "talAvatar",
  userPermissions: "talPermissions",
  kpi_permission: "kpi_permission",
  is_ftes: "is_ftes",
  dimension_permission: "dimension_permission",
  weeklyHas: "weeklyHas",
  userInfo: "userInfo",
  atTask: "atTask",
  orgPermisson: "org_permisson",
  cepPermisson: "cepPermisson"
};
